import React from 'react';
import './animation1.less';

const Animation1 = () => {
    return <div className="c-animation1"></div>;
};

export default Animation1;
